/** Brand and file marks for footage pickers. Sized with className, like the other icons. */

export function YoutubeIcon({ className = 'h-5 w-5', title }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden={title ? undefined : true} role={title ? 'img' : undefined}>
      {title ? <title>{title}</title> : null}
      <path fill="#FF0033" d="M23.5 6.19a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.5A3.02 3.02 0 0 0 .5 6.19 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.81 3.02 3.02 0 0 0 2.12 2.14c1.88.5 9.38.5 9.38.5s7.5 0 9.38-.5a3.02 3.02 0 0 0 2.12-2.14A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.81z" />
      <path fill="#fff" d="M9.75 15.57V8.43L15.84 12l-6.09 3.57z" />
    </svg>
  );
}

export function VeoIcon({ className = 'h-5 w-5', title }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden={title ? undefined : true} role={title ? 'img' : undefined}>
      {title ? <title>{title}</title> : null}
      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="6" fill="#111111" stroke="#fff" strokeWidth="1.5" />
      <path fill="#fff" d="M6.7 17.15 12 6.55l5.3 10.6h-2.45L12 11.35 9.15 17.15H6.7z" />
    </svg>
  );
}

export function Mp4Icon({ className = 'h-5 w-5', title }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden={title ? undefined : true} role={title ? 'img' : undefined}>
      {title ? <title>{title}</title> : null}
      <path
        fill="currentColor"
        d="M6.2 2.4h7.1c.3 0 .6.12.8.34l4.16 4.16c.22.22.34.5.34.8v13.1a1.8 1.8 0 0 1-1.8 1.8H6.2a1.8 1.8 0 0 1-1.8-1.8V4.2a1.8 1.8 0 0 1 1.8-1.8z"
        opacity="0.16"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
        d="M6.2 3.2h6.7L18.4 8.7V19.8a1 1 0 0 1-1 1H6.2a1 1 0 0 1-1-1V4.2a1 1 0 0 1 1-1z"
      />
      <path fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" d="M12.8 3.4V8.2h4.9" />
      <text
        x="11.6"
        y="16.6"
        textAnchor="middle"
        fill="currentColor"
        fontSize="5.2"
        fontWeight="700"
        fontFamily="Inter, ui-sans-serif, system-ui, sans-serif"
      >
        MP4
      </text>
    </svg>
  );
}
